export const SlaLevelType = {
  LOAN_ROLE: 'LoanRole',
  SECURITY_GROUP: 'SecurityGroup',
  USER: 'User',
  MANAGER: 'Manager',
};

export const SlaType = {
  GENERAL_BUSINESS_DAYS: 'GeneralBusinessDays',
  REGULAR_HOURS: 'RegularHours',
};

export const slaLevelTypeOptions = [
  { name: 'Manager', value: SlaLevelType.MANAGER },
  { name: 'Loan Role', value: SlaLevelType.LOAN_ROLE },
  { name: 'Security Group', value: SlaLevelType.SECURITY_GROUP },
  { name: 'User', value: SlaLevelType.USER },
];

export const slaTypeOptions = [
  { name: 'Business Days', value: SlaType.GENERAL_BUSINESS_DAYS },
  { name: 'Hours', value: SlaType.REGULAR_HOURS },
];

export const DENIED_SLA_GROUP_NAME = 'Denied';
